/**
 * MailchimpForm.js
 *
 * Setup Mailchimp signup form functionality
 *
 * @param $ jquery
 */

const MailchimpForm = ($) => {
	"use strict";

	const send = (data) => {
		const url = main_script.ajaxurl; // eslint-disable-line

		$.post(url, data, function (response) {

			if (response.success) {

				// hide form, show success message
				$("#mailing-list-form").hide();
				$("#mailing-list-success").show();

				// close form after 3 seconds, allow body to scroll
				setTimeout(function () {
					$("#open-popup").slideToggle();
					$("html").css({ "overflow-y": "scroll", "overflow-x": "hidden" });
				}, 3000);
			} else {
				$("#response-area")
					.show()
					.addClass("msg-error")
					.removeClass("msg-success")
					.html(response.data.message);
			}

			const formFields = Object.keys(response.data);

			formFields.forEach((field) => {
				$(`#${field}-response-area`).html(response.data[field]);
			});
		});
	};

	const init = () => {
		$("#mailchimp-submit").click(function (e) {
			e.preventDefault();

			const fromFieldNames = ["fname", "lname", "email"];

			fromFieldNames.forEach((field) => {
				$(`#${field}-response-area`).html("");
			});

			let grecaptcha = window.grecaptcha;

			grecaptcha
				.execute("6LfTQ9IZAAAAAGw6ZxxA--bloJA2NeuXTCOSNdEs", {
					action: "mailchimp",
				})
				.then((token) => {
					let recaptchaResponse = document.getElementById("recaptcha_response");
					recaptchaResponse.value = token;
					const ajaxFormData = $("#mailchimp-form").serialize();
					send(ajaxFormData);
				});
		});
	};

	init();
};

export default MailchimpForm;
